import { Content, ContentWrapper, Header } from '../../layouts'
import MaintenanceInfo from './MaintenanceInfo'

const MaintenancePage = () => {
  return (
    <>
      <Header />
      <ContentWrapper>
        <Content>
          <MaintenanceInfo />
        </Content>
      </ContentWrapper>
    </>
  )
}

export default MaintenancePage
